import { render, staticRenderFns } from "./TableWithJump.vue?vue&type=template&id=3153a3fd&scoped=true"
import script from "./TableWithJump.vue?vue&type=script&lang=js"
export * from "./TableWithJump.vue?vue&type=script&lang=js"
import style0 from "./TableWithJump.vue?vue&type=style&index=0&id=3153a3fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153a3fd",
  null
  
)

export default component.exports